(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }


document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  if (!header) return;

  // Shopify видає тип сторінки напряму:
  const isHome = '{{ request.page_type }}' === 'index';

  /* Пороги */
  const HOME_FIX_THRESHOLD   = 100;  // коли header стає fixed (прозорий)
  const HOME_SOLID_THRESHOLD = 300;  // коли стає solid + поведінка «show‑on‑scroll‑up»
  const OTHER_FIX_THRESHOLD  = 250;  // для всіх не‑home сторінок

  let lastScroll = window.pageYOffset || document.documentElement.scrollTop;

  function updateHeader() {
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const scrollingDown = scroll > lastScroll;

    /* ===== ГОЛОВНА ===== */
    if (isHome) {
      if (scroll < HOME_FIX_THRESHOLD) {
        /* 0 – 100 px: sticky + прозорий, завжди видимий */
        header.classList.remove('fixed', 'header--solid', 'header--hidden');
        header.classList.add('header--transparent');
      } else if (scroll < HOME_SOLID_THRESHOLD) {
        /* 100 – 300 px: fixed + прозорий, завжди видимий */
        header.classList.add('fixed', 'header--transparent');
        header.classList.remove('header--solid', 'header--hidden');
      } else {
        /* 300 px +: fixed + solid, видимий тільки при скролі вгору */
        header.classList.add('fixed', 'header--solid');
        header.classList.remove('header--transparent');
        header.classList.toggle('header--hidden', scrollingDown);
      }

    /* ===== УСІ ІНШІ СТОРІНКИ ===== */
    } else {
      if (scroll < OTHER_FIX_THRESHOLD) {
        /* 0 – 250 px: sticky + solid, ховається коли скролимо вниз */
        header.classList.remove('fixed');
        header.classList.add('header--solid');
        header.classList.toggle('header--hidden', scrollingDown);
      } else {
        /* 250 px +: fixed + solid, показується лише при скролі вгору */
        header.classList.add('fixed', 'header--solid');
        header.classList.toggle('header--hidden', scrollingDown);
      }
    }

    lastScroll = scroll <= 0 ? 0 : scroll; // iOS bounce
  }

  /* запуск */
  updateHeader();
  window.addEventListener('scroll', updateHeader);
});
  
  } catch(e) { console.error(e); }
})();
})();
